
















































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator"
import { AgGridVue } from "ag-grid-vue"
import "ag-grid-enterprise"
import "@ag-grid-community/styles/ag-grid.css"
import "@ag-grid-community/styles/ag-theme-alpine.css"
import { ColDef, GridReadyEvent, ExcelExportParams } from "@ag-grid-community/core"
import {
	obterDisplayClienteParaGridDePedidos,
} from '@/shareds/venda-shareds'
import { descricaoDoStatusSefaz } from "@/shareds/fiscal/status-da-nota"
import { formatarMoeda } from "@/shareds/formatadores"
import { GridOptions, LicenseManager } from "ag-grid-enterprise"
import TotalVendaRenderer from "./components-grid-demonstracao/TotalVendaRenderer.vue"
import ClienteGridDemonstracao from "./components-grid-demonstracao/ClienteGridDemonstracao.vue"
import NotaFiscalDaGridDePedidos from "./components-grid-pedidos/NotaFiscalDaGridDePedidos.vue"
import { dateTimeToPtBrFormat } from "@/shareds/date/date-utils"
import Confirmacao from "./Confirmacao.vue"
import ConfirmacaoComMotivoFiscal from "./ConfirmacaoComMotivoFiscal.vue"
import DialogoDeDetalhesDaVenda from "../venda/DialogoDeDetalhesDaVenda.vue"
import { FindVendaUseCase } from "@/usecases"
import DialogoDeCancelarPagamentos from "../venda/DialogoDeCancelarPagamentos.vue"
import RodapePersonalizado from "./data-tables/RodapePersonalizado.vue"
import { AG_GRID_LOCALE_BR } from '@ag-grid-community/locale'
import InformacoesDeTransporteGrid from "./components-grid-pedidos/InformacoesDeTransporteGrid.vue"
import CanalDeVendasGrid from "./components-grid-pedidos/CanalDeVendasGrid.vue"
import AcoesDaGridDePedidos from "./components-grid-pedidos/AcoesDaGridDePedidos.vue"
import DialogoDeVerificacaoDeProdutos from "@/views/application/venda/DialogoDeVerificacaoDeProdutos.vue"
import { PedidoListagem, ResumoDaVenda } from "@/models/venda/Venda"
import DialogoDeEdicaoDePedido from "../venda/DialogoDeEdicaoDePedido.vue"
import DialogoDeEdicaoDeColeta from '@/components/venda/DialogoDeEdicaoDeColeta.vue'
import ConfirmacaoComMotivo from "./ConfirmacaoComMotivo.vue"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"

let nfTooltipEl: HTMLDivElement | null = null

function getNfTooltipEl(): HTMLDivElement {
	if (!nfTooltipEl) {
		nfTooltipEl = document.createElement('div')
		nfTooltipEl.className = 'nf-tooltip'
		document.body.appendChild(nfTooltipEl)
	}
	return nfTooltipEl
}

function hideNfTooltip() {
	if (!nfTooltipEl) return
	nfTooltipEl.classList.remove('nf-tooltip-visible')
}

function showAmbienteTooltip(targetEl: HTMLElement, ambiente: string) {
	if (!ambiente) return

	const tooltip = getNfTooltipEl()
	tooltip.innerHTML = `
    <div class="nf-tooltip-row">
      <div class="nf-tooltip-title">${ambiente}</div>
    </div>
  `

	const rect = targetEl.getBoundingClientRect()
	const top = rect.bottom + 4 + window.scrollY
	const left = rect.left + window.scrollX

	tooltip.style.top = `${top}px`
	tooltip.style.left = `${left}px`
	tooltip.classList.add('nf-tooltip-visible')
}

function showTextoTooltip(targetEl: HTMLElement, titulo: string, descricao: string) {
	const tooltip = getNfTooltipEl()
	tooltip.innerHTML = `
    <div class="nf-tooltip-row">
      <div class="nf-tooltip-title">${titulo}</div>
      <div class="nf-tooltip-subtitle">${descricao}</div>
    </div>
  `

	const rect = targetEl.getBoundingClientRect()
	const top = rect.bottom + 4 + window.scrollY
	const left = rect.left + window.scrollX

	tooltip.style.top = `${top}px`
	tooltip.style.left = `${left}px`
	tooltip.classList.add('nf-tooltip-visible')
}

function showNotasTooltip(targetEl: HTMLElement, notas: any[]) {
	const notasValidas = (notas || []) as any[]
	if (!notasValidas.length) return

	const tooltip = getNfTooltipEl()
	const html = notasValidas
		.map((nota: any) => {
			const descricao = descricaoDoStatusSefaz(nota.cstat, nota.inutilizacaoDispensada)
			const status = descricao
				? `${nota.cstat} - ${descricao}`
				: (nota.cstat || '')

			return `
        <div class="nf-tooltip-row">
          <div class="nf-tooltip-title">
            ${nota.nnf}/${nota.serie} - ${nota.modelo}
          </div>
          ${status
		? `<div class="nf-tooltip-subtitle">${status}</div>`
		: ''
}
        </div>
      `
		})
		.join('')

	tooltip.innerHTML = html

	const rect = targetEl.getBoundingClientRect()
	const top = rect.bottom + 4 + window.scrollY
	const left = rect.left + window.scrollX

	tooltip.style.top = `${top}px`
	tooltip.style.left = `${left}px`
	tooltip.classList.add('nf-tooltip-visible')
}



LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-066566}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Almode}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Almode}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Almode}_need_to_be_licensed___{Almode}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_September_2025}____[v3]_[01]_MTc1NzE5OTYwMDAwMA==9c5f2e3bec6aeda6768b2994297ce2a8")

@Component({
	components: {
		AgGridVue,
		Confirmacao,
		ConfirmacaoComMotivoFiscal,
		DialogoDeDetalhesDaVenda,
		DialogoDeCancelarPagamentos,
		RodapePersonalizado,
		DialogoDeVerificacaoDeProdutos,
		InformacoesDeTransporteGrid,
		CanalDeVendasGrid,
		AcoesDaGridDePedidos,
		NotaFiscalDaGridDePedidos,
		DialogoDeEdicaoDePedido,
		DialogoDeEdicaoDeColeta,
		ConfirmacaoComMotivo,
	},
})
export default class GridDePedidos extends Vue {
	@Ref() agGrid!: AgGridVue | undefined
	@Ref() confirmacao!: ConfirmacaoComMotivo
	@Ref() dialogoDeDetalhesDaVenda!: DialogoDeDetalhesDaVenda
	@Ref() confirmacaoComMotivoFiscal!: ConfirmacaoComMotivoFiscal
	@Ref() confirmacaoNotaComMotivoFiscal!: ConfirmacaoComMotivoFiscal
	@Ref() confirmacaoDevolverPedido!: Confirmacao
	@Ref() confirmacaoDeCancelamentoComNotaComplementar!: Confirmacao
	@Ref() rodapePersonalizado!: RodapePersonalizado
	@Ref() dialogoDeVerificacaoDeProdutos!: DialogoDeVerificacaoDeProdutos
	@Ref() dialogoDeEdicaoDePedido!: DialogoDeEdicaoDePedido
	@Ref() dialogoDeEdicaoDeColeta!: DialogoDeEdicaoDeColeta
	@Prop({ type: Array, required: true }) vendas!: ResumoDaVenda[]
	@Prop({ type: Number, required: false }) total?: number
	@Prop({ type: Boolean, default: false }) loading!: boolean
	@Prop({ type: Object }) paginacao!: { page: number; itemsPerPage: number; itemsLength: number }
	@Prop({ type: Boolean, default: false }) deveVerificarProdutos!: boolean
	@Prop({ type: Boolean, default: false }) selecionavel!: boolean

	private gridApi: any = null
	selecionados: ResumoDaVenda[] = []

	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	findVendaUseCase = new FindVendaUseCase()
	vendaControlada: ResumoDaVenda | null = null

	AG_GRID_LOCALE_BR = AG_GRID_LOCALE_BR

	columnDefs: ColDef[] = (() => {
		const isDevolucao = window.location.pathname.includes('/devolucao-pedidos')

		const cols: ColDef[] = [
			{ headerName: "Identificador", width: 250, field: "identificador" },
			isDevolucao
				? { headerName: "Identificador Externo 2", field: "identificadorExterno2" }
				: { headerName: "Identificador Externo",  field: "identificadorExterno"  },
			{ headerName: "Loja", field: "loja" },
			...(!isDevolucao ? [{
				headerName: "Canal de vendas",
				field: "canalDeVendas",
				cellRenderer: (params) => {
					const ComponentClass = Vue.extend(CanalDeVendasGrid)
					return new ComponentClass({
						propsData: { params },
					}).$mount().$el
				},
			}] : []),
			{
				headerName: "Cliente", field: "displayCliente",
				cellRenderer: (params) => {
					const ComponentClass = Vue.extend(ClienteGridDemonstracao)
					return new ComponentClass({
						propsData: { params },
					}).$mount().$el
				},
			},
			{ headerName: "Data", field: "displayDataHora" },
			{ headerName: "Situação", field: "displaySituacao" },
			{
				headerName: "NF/Série",
				field: "displayNfSerie",
				cellRenderer: (params: any) => {
					const venda = params.data
					const notas = (venda?.notas || []) as any[]
					const ultimaNota = notas.length ? notas[notas.length - 1] : null
					const outrasNotas = notas.slice(0, -1)
					const container = document.createElement('div')
					container.className = 'nf-cell-wrapper'
					const wrapper = document.createElement('div')
					wrapper.className = 'd-flex justify-end align-items-center'
					if (ultimaNota) {
						const circle = document.createElement('span')
						circle.className =
							'circle-icon ' +
							(venda.displayAmbiente === 'Homologação' ? 'grey' : 'green')
						wrapper.appendChild(circle)
					}
					const text = document.createElement('span')
					text.className = 'text-no-wrap pr-1'
					if (ultimaNota && ultimaNota.cstat === '101') {
						text.classList.add('text-decoration-line-through')
					}
					text.textContent = venda.displayNfSerie || ''
					wrapper.appendChild(text)
					text.addEventListener('mouseenter', () =>
						showAmbienteTooltip(text, venda.displayAmbiente),
					)
					text.addEventListener('mouseleave', () => hideNfTooltip())
					if (outrasNotas.length > 0) {
						const dots = document.createElement('span')
						dots.className = 'nf-dots'
						dots.textContent = '⋯'
						dots.addEventListener('mouseenter', () =>
							showNotasTooltip(dots, outrasNotas),
						)
						dots.addEventListener('mouseleave', () => hideNfTooltip())
						wrapper.appendChild(dots)
					}
					container.appendChild(wrapper)
					return container
				},
			},
			{ headerName: "Último Status", field: "displayStatusDaNota" },
			{
				headerName: "Total (R$)", field: "displayTotalDoPedido",
				cellRenderer: (params) => {
					const ComponentClass = Vue.extend(TotalVendaRenderer)
					return new ComponentClass({
						propsData: { params },
					}).$mount().$el
				},
				tooltipField: "displayTipoDeVenda",
			},
			...(!isDevolucao ? [{
				headerName: "Transporte", width: 150, field: "getModalidadeDoFrete", tooltipField: "displayModalidadeDoFrete",
				cellRenderer: (params) => {
					const ComponentClass = Vue.extend(InformacoesDeTransporteGrid)
					return new ComponentClass({
						propsData: { params },
					}).$mount().$el
				},
			}] : []),
			{
				headerName: "Ações",
				field: "acoes",
				cellRenderer: (params) => {
					const ComponentClass = Vue.extend(AcoesDaGridDePedidos)
					const instance = new ComponentClass({
						propsData: { params },
					})
					instance.$on("acao", (acaoData) => {
						this.handleAcaoClicada(acaoData.acao, acaoData.dados)
					})
					instance.$on("mostrar-tooltip", ({ elemento, titulo, descricao }) =>
						showTextoTooltip(elemento, titulo, descricao),
					)
					instance.$on("ocultar-tooltip", () => hideNfTooltip())
					return instance.$mount().$el
				},
			},
		]

		return cols
	})()

	gridOptions: GridOptions = {
		rowHeight: 40,
		tooltipShowDelay: 100,
		rowSelection: 'multiple',
		suppressRowClickSelection: true,
	}

	created() {
		const colunaIdentificador = this.columnDefs.find(col => col.field === 'identificador')
		if (!colunaIdentificador) return
		colunaIdentificador.checkboxSelection = (params) => this.selecionavel && !params.node.rowPinned
		colunaIdentificador.headerCheckboxSelection = () => this.selecionavel
	}

	onSelectionChanged() {
		if (!this.gridApi) return
		this.selecionados = this.gridApi.getSelectedRows().filter(row => !row.isTotalRow)
	}

	@Watch('selecionavel')
	onChangeSelecionavel() {
		if (!this.selecionavel) this.limparSelecao()
		if (!this.gridApi) return
		this.gridApi.refreshHeader()
		this.gridApi.refreshCells({ force: true })
	}

	limparSelecao() {
		if (this.gridApi) this.gridApi.deselectAll()
		this.selecionados = []
	}

	defaultColDef = {
		flex: 1,
		minWidth: 10,
		tooltipField: "tooltip",
		enableRowGroup: true,
	}

	levalOld = 0

	reloadGrid = false

	onGridReady(params: GridReadyEvent) {
		this.gridApi = params.api
		this.refreshGridData()
	}

	getData(): any[] {
		return this.itensFormatados
	}

	formatarVenda(venda: ResumoDaVenda) {
		return {
			...venda,
			displayCliente: obterDisplayClienteParaGridDePedidos(venda),
			displayTotalDoPedido: this.displayTotalDoPedido(venda),
			displayStatusDaNota: this.displayStatusDaNota(venda),
			displayNfSerie: this.displayNfSerie(venda),
			displayDataHora: this.displayDataFormatada(venda),
			displayAmbiente: this.getAmbiente(venda),
			displayTipoDeVenda: this.getTipoDeVenda(venda),
			displaySituacao: this.displaySituacao(venda),
			displayModalidadeDoFrete: this.displayModalidadeDoFrete(venda),
			isEntregaExpressa: this.isEntregaExpressa(venda),
			deveVerificarProdutos: this.deveVerificarProdutos,
			displayNotasTooltip: this.buildNotasTooltip(venda),
		}
	}

	get itensFormatados() {
		return this.vendas.map(venda => this.formatarVenda(venda))
	}

	displaySituacao(venda: ResumoDaVenda) {
		const situacaoDoPedido = venda.situacaoPedido
		return situacaoDoPedido
	}

	displayDataFormatada(venda: ResumoDaVenda) {
		if (!venda.dataHora) return ''
		return dateTimeToPtBrFormat(venda.dataHora)
	}

	displayTotalDoPedido(venda: ResumoDaVenda) {
		if (!venda.total) return '0,00'
		return formatarMoeda(venda.total)
	}

	displayStatusDaNota(venda: ResumoDaVenda) {
		const nota = this.getUltimaNota(venda)
		if (!nota) return ''

		const descricao = descricaoDoStatusSefaz(nota.cstat, nota.inutilizacaoDispensada)
		return descricao
			? `${nota.cstat} - ${descricao}`
			: (nota.cstat || '')
	}

	displayNfSerie(venda: ResumoDaVenda) {
		const nota = this.getUltimaNota(venda)
		if (!nota) return ''
		return `${nota.modelo} ${nota.nnf} / ${nota.serie}`
	}

	getAmbiente(venda: ResumoDaVenda) {
		const nota = this.getUltimaNota(venda)
		if (!nota) return ''
		return nota.ambiente === 'Homologação' ? 'Homologação' : 'Produção'
	}


	isEntregaExpressa(venda: ResumoDaVenda) {
		const tipo = venda.informacoesDeTransporte?.tipoDeFrete ?? ''
		const tipoDeFreteEhExpressa = /^entrega\s+expressa$|^expressa$|^entrega\s+amanhã$|^entrega\s+hoje$/i.test(tipo.trim())
		const transportadoraEhExpressa = venda.informacoesDeTransporte?.fornecedor?.isEntregaExpressa === true
		return tipoDeFreteEhExpressa && transportadoraEhExpressa
	}

	displayModalidadeDoFrete(venda: ResumoDaVenda) {
		if (this.isEntregaExpressa(venda)) return venda.informacoesDeTransporte?.tipoDeFrete
		return this.getModalidadeDoFrete(venda) !== 'Sem Frete' ? 'Possui transportadora' : 'Retirada local'
	}

	getModalidadeDoFrete(venda: ResumoDaVenda) {
		return venda.informacoesDeTransporte.modalidadeDeFrete ? venda.informacoesDeTransporte.modalidadeDeFrete : 'Sem Frete'
	}

	getTipoDeVenda(venda: ResumoDaVenda) {
		if (venda.isDemonstracao && venda.total > 0) return venda.modalidade
		else if (venda.total >= 0 && !venda.isDemonstracao) return 'Venda'
		else return 'Devolução'
	}

	getRowStyle(params: any) {
		const hasChildren = params.node.__hasChildren
		const isDarkTheme = this.$vuetify.theme.dark
		const isDevolucao = window.location.pathname.includes('/devolucao-pedidos')

		if (params.data?.envioPedidoParaApiDeIntegracaoPendente) {
			return {
				backgroundColor: isDarkTheme ? '#5c1a1a' : '#ffcdd2',
				color: isDarkTheme ? '#ffcdd2' : '#b71c1c',
			}
		}

		if (params.data?.isEntregaExpressa) {
			return {
				backgroundColor: isDarkTheme ? '#5c4a00' : '#fff59d',
				color: isDarkTheme ? '#ffe57f' : 'inherit',
			}
		}

		if (isDevolucao && params.data?.situacaoPedido === 'Pendente') {
			return {
				backgroundColor: isDarkTheme ? '#5a4a00' : '#fff9c4',
				color: isDarkTheme ? '#ffe57f' : 'inherit',
			}
		}

		if (hasChildren === undefined) return null

		const backgroundColor = hasChildren
			? (isDarkTheme ? "#333333" : "#D3D3D3")
			: (isDarkTheme ? "#1E1E1E" : "white")

		return { backgroundColor }
	}

	@Watch('$vuetify.theme.dark')
	onThemeChange() {
		if (this.gridApi) {
			this.gridApi.refreshCells({ force: true })
			this.gridApi.redrawRows()
			this.gridApi.refreshClientSideRowModel('group')
		}
	}

	@Watch('loading')
	changeLoading() {
		this.loading
			? this.gridApi.showLoadingOverlay()
			: this.gridApi.hideOverlay()

	}

	async handleAcaoClicada(acao: string, venda: ResumoDaVenda) {
		this.vendaControlada = venda
		if (acao === 'verificar-produtos') {
			await this.$nextTick()

			this.dialogoDeVerificacaoDeProdutos?.mostrar()
			return
		}

		if (acao === 'reenviar-pedido-para-api') {
			hideNfTooltip()
			this.$emit('reenviarPedidoParaApi', venda)
			this.vendaControlada = null
			return
		}

		if (acao === "cancelar-com-motivo" || acao === "cancelar-com-motivo-fiscal") {
			const podeCancelar = await this.podeCancelarPedidoComNotaComplementar(venda)

			if (!podeCancelar) return
		}

		this.$nextTick(() => {
			if (acao === "cancelar-com-motivo") this.confirmacao.mostrarSimplificado()
			else if (acao === "cancelar-com-motivo-fiscal") this.confirmacaoComMotivoFiscal.mostrar()
			else if (acao === "detalhes") this.dialogoDeDetalhesDaVenda.mostrar(venda)
			else if (acao === 'cancelar-nota') this.confirmacaoNotaComMotivoFiscal.mostrar()
			else if (acao === 'devolver') this.confirmacaoDevolverPedido.mostrar()
			else if (acao === 'editar-coleta') this.dialogoDeEdicaoDeColeta.mostrar()
			else if (acao === 'editar-pedido') this.dialogoDeEdicaoDePedido.mostrar()
		})
	}

	async podeCancelarPedidoComNotaComplementar(venda: ResumoDaVenda) {
		try {
			const vendaDetalhada = await this.findVendaUseCase.getVendaComReferencias(venda.id)

			if (!vendaDetalhada.pedido || !vendaDetalhada.pedido.idNotaDeTransferenciaComplementar) return true

			if (vendaDetalhada.notaDeTransferenciaComplementarPendente) {
				AlertModule.setError(
					"A nota de transferência do estoque complementar ainda não foi recebida. " +
					"Receba a nota antes de cancelar o pedido.",
				)
				return false
			}

			await this.$nextTick()

			return await this.confirmacaoDeCancelamentoComNotaComplementar.mostrar()
		} catch (error: any) {
			AlertModule.setError(error)
			return false
		}
	}

	cancelarVenda(venda: ResumoDaVenda, motivoDoCancelamentoFiscal?: any) {
		this.$emit("confirmarCancelamento", venda, motivoDoCancelamentoFiscal)
		this.vendaControlada = null
	}

	cancelarNotasFiscais(venda: ResumoDaVenda, motivoDoCancelamentoFiscal?: any) {
		this.$emit("cancelarNotasFiscais", venda, motivoDoCancelamentoFiscal)
		this.vendaControlada = null
	}

	displayNotasFiscais(venda: ResumoDaVenda): string {
		return venda.notas
			.filter(({ cstat }) => !['101', '102'].includes(cstat))
			.map(nota => `Nota ${nota.nnf} / ${nota.serie}`)
			.join('<br>')
	}

	devolverPedido(venda: ResumoDaVenda) {
		this.$emit("devolverPedido", venda)
		this.vendaControlada = null
	}

	navegar(page) {
		this.$emit("paginacaoPedidos", page)
	}

	@Watch('$vuetify.theme.dark')
	onChangeTheme() {
		this.reloadGrid = true
		setTimeout(() => {
			this.reloadGrid = false
		}, 1)
	}

	autoSizeStrategy: {
		type: "fitGridWidth"
		defaultMinWidth: number
		columnLimits: Array<{ colId: string; minWidth: number }>
	} = {
		type: "fitGridWidth",
		defaultMinWidth: 70,
		columnLimits: [
			{
				colId: "identificador",
				minWidth: 200,
			},
			{
				colId: "identificadorExterno",
				minWidth: 140,
			},
			{
				colId: "displayNfSerie",
				minWidth: 100,
			},
			{
				colId: "displayStatusDaNota",
				minWidth: 140,
			},
			{
				colId: "displayTotalDoPedido",
				minWidth: 130,
			},
		],
	}

	//CASO QUEIRA IMPORTAR EM FORMATO CSV 
	
	/*exportarCsv() {
		if (!this.gridApi) return

		const allColumns = this.gridApi.getAllDisplayedColumns()

		const columnKeys = allColumns
			.filter(col => col.getColDef().field !== 'acoes') 
			.map(col => col.getColId())

		this.gridApi.exportDataAsExcel({
			fileName: 'pedidos.csv',
			columnKeys, 
			processCellCallback: (params) => {
				const field = params.column.getColDef().field

				if (field === 'getModalidadeDoFrete') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.informacoesDeTransporte?.modalidadeDeFrete ?? ''
				}

				if (field === 'canalDeVendas') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.canalDeVendas?.nome ?? ''
				}

				if (field === 'displayCliente') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.cpfDoCliente ?? ''
				}

				return params.value
			},
		})
	} */

	onGridSizeChanged() {
		if (!this.gridApi) return

		this.gridApi.sizeColumnsToFit()
	}

	atualizarLinhaTotal() {
		if (!this.gridApi) return

		let totalPagina = 0

		this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
			if (node.group || node.rowPinned) return

			const venda = node.data as ResumoDaVenda
			const valor = Number((venda?.total as any) ?? 0)

			if (!Number.isNaN(valor)) {
				totalPagina += valor
			}
		})

		const pinnedBottomRowData = [
			{
				identificador: 'Total (R$)',
				displayTotalDoPedido: formatarMoeda(totalPagina),
				total: totalPagina,
				isTotalRow: true,
			},
		]

		this.gridApi.setPinnedBottomRowData(pinnedBottomRowData)
	}

	@Watch('vendas', { deep: true })
	onVendasChange() {
		this.$nextTick(() => {
			this.atualizarLinhaTotal()
		})
	}

	exportarExcel() {
		if (!this.gridApi) return

		const allColumns = this.gridApi.getAllDisplayedColumns()

		const columnKeys = allColumns
			.filter(col => col.getColDef().field !== 'acoes')
			.map(col => col.getColId())

		const params: ExcelExportParams = {
			fileName: 'pedidos.xlsx',
			sheetName: 'Pedidos',
			columnKeys,
			processCellCallback: (params) => {
				const field = params.column.getColDef().field

				if (field === 'getModalidadeDoFrete') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.informacoesDeTransporte?.modalidadeDeFrete ?? ''
				}

				if (field === 'canalDeVendas') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.canalDeVendas?.nome ?? ''
				}

				if (field === 'displayCliente') {
					const venda = params.node?.data as ResumoDaVenda
					return venda?.cpfDoCliente ?? ''
				}

				return params.value
			},
		}

		this.gridApi.exportDataAsExcel(params)
	}

	buildNotasTooltip(venda: ResumoDaVenda): string {
		if (!venda.notas || !venda.notas.length) return ''

		return venda.notas
			.map(nota => {
				const descricao = descricaoDoStatusSefaz(nota.cstat, nota.inutilizacaoDispensada)
				const status = descricao
					? `${nota.cstat} - ${descricao}`
					: (nota.cstat || '')
				return `${nota.nnf}/${nota.serie} - ${nota.modelo}${status ? ' | ' + status : ''}`
			})
			.join('\n') 
	}

	getUltimaNota(venda: ResumoDaVenda) {
		const notas = venda.notas || []
		if (!notas.length) return null
		return notas[notas.length - 1]
	}

	async atualizarStatusDoPedido(vendaAtualizada: ResumoDaVenda) {
		try {
			const venda = await this.findVendaUseCase.get(vendaAtualizada.id)

			const vendaResumida = {
				...vendaAtualizada,
				vendaOrigem:
					vendaAtualizada.vendaOrigem === undefined
						? ''
						: vendaAtualizada.vendaOrigem,
				situacaoPedido: vendaAtualizada.pedido?.situacao,
				notas: venda.notas,
			} as ResumoDaVenda

			const indice = this.vendas.findIndex(
				venda => vendaAtualizada.id === venda.id,
			)
			if (indice === -1) return

			this.vendas.splice(indice, 1, vendaResumida)
			this.$emit("paginacaoPedidos")
		} catch (e) {
			AlertModule.setError(
				'Erro ao atualizar o status na tela, comunique o suporte' + e,
			)
		}
	}

	async atualizarTotalDoPedido(vendaAtualizada: ResumoDaVenda) {
		try {
			const vendaResumida = {
				...vendaAtualizada,
				vendaOrigem:
					vendaAtualizada.vendaOrigem === undefined
						? ''
						: vendaAtualizada.vendaOrigem,
				total: vendaAtualizada.total,
			} as ResumoDaVenda

			const indice = this.vendas.findIndex(
				venda => vendaAtualizada.id === venda.id,
			)
			if (indice === -1) return

			this.vendas.splice(indice, 1, vendaResumida)

			this.$emit("paginacaoPedidos")
		} catch (e) {
			AlertModule.setError(
				'Erro ao atualizar o total na tela, comunique o suporte' + e,
			)
		}
	}

	private refreshGridData() {
		if (!this.gridApi) return

		this.gridApi.setRowData(this.getData())

		this.$nextTick(() => {
			this.atualizarLinhaTotal()
		})
	}

	async exportarExcelComDados(todasAsVendas: PedidoListagem[]) {
		if (!this.gridApi) return

		const dadosPaginaAtual = this.itensFormatados
		const dadosCompletos = [...todasAsVendas].sort((a, b) => {
			const da = new Date(a.dataHora as any).getTime()
			const db = new Date(b.dataHora as any).getTime()
			return db - da 
		})

		const totalGeral = dadosCompletos.reduce((acc, v) => {
			const valor = Number(v.total ?? 0)
			return Number.isNaN(valor) ? acc : acc + valor
		}, 0)

		this.gridApi.setRowData(dadosCompletos)

		this.gridApi.setPinnedBottomRowData([
			{
				identificador: 'Total (R$)',
				displayTotalDoPedido: totalGeral, 
			},
		])

		const allColumns = this.gridApi.getAllDisplayedColumns()
		const columnKeys = allColumns
			.filter(col => col.getColDef().field !== 'acoes')
			.map(col => col.getColId())

		const params: ExcelExportParams = {
			fileName: 'pedidos.xlsx',
			sheetName: 'Pedidos',
			columnKeys,
			processCellCallback: (params) => {
				const field = params.column.getColDef().field
				const venda = params.node?.data as PedidoListagem | undefined

				if (field === 'displayTotalDoPedido' && params.node?.rowPinned === 'bottom') {
					return params.value 
				}

				if (params.node?.rowPinned === 'bottom') {
					if (field === 'identificador') return params.value 
					return '' 
				}

				switch (field) {
					case 'displayCliente':
						return venda?.cpfDoCliente ?? ''

					case 'displayDataHora':
						return venda?.dataHora
							? new Date(venda.dataHora as any).toLocaleString('pt-BR')
							: ''

					case 'displaySituacao':
						return venda?.situacaoPedido ?? ''

					case 'displayNfSerie': {
						const notas = venda?.notas || []
						if (!notas.length) return ''
						const n = notas[notas.length - 1]
						return `${n.modelo} ${n.nnf} / ${n.serie}`
					}

					case 'displayStatusDaNota':
						return venda?.ultimoStatus ?? ''

					case 'displayTotalDoPedido':
						return venda?.total ?? 0

					case 'getModalidadeDoFrete':
						return venda?.modalidadeFrete ?? ''

					case 'canalDeVendas':
						return venda?.canalDeVendas ?? ''
				}

				return params.value
			},
		}

		this.gridApi.exportDataAsExcel(params)

		this.gridApi.setRowData(dadosPaginaAtual)
		this.atualizarLinhaTotal()
	}

	get pedidosDevolucao() {
		return window.location.pathname.includes('/devolucao-pedidos');
	}

	get telaDePedidosNormal() {
		return window.location.pathname.includes('/pedidos') &&
			!window.location.pathname.includes('/devolucao-pedidos')
	}
	
}
